import { ACTION_SET_ERROR, ACTION_CLEAR_ERROR, ACTION_CLEAR_ERRORS } from "../action";


export default function reduceErrors(state = {}, action){
	switch (action.type) {
		case ACTION_SET_ERROR:
			return {
				...state,
				[action.payload.id]: action.payload.error,
			};
		case ACTION_CLEAR_ERROR:
			return state.filter((error, id)=> id === action.payload.id);
		case ACTION_CLEAR_ERRORS:
			return {};
	}
	return state;
};